export default __webpack_public_path__ + "static/pre-trade-868e42b3bdd0c2d4b7aa11344e437adb.webp";